import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Apple, Smartphone, Edit, History, ShieldAlert } from "lucide-react";



const statusColors = {
  development: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  testing: "bg-yellow-500/10 text-yellow-600 border-yellow-500/20",
  production: "bg-green-500/10 text-green-600 border-green-500/20",
  archived: "bg-gray-500/10 text-gray-600 border-gray-500/20",
};

const isEnabled = (value) => value === true || value === 1 || value === "1" || value === "true";

export function AppCard({ app, onEdit, onViewHistory }) {
  return (
    <Card className="version-app-card">
      <div className="version-app-header flex items-start justify-between">
        <div className="flex items-center gap-3">
      
          <div>
            <h3>{app.app_name}</h3>
            <p>
              Updated {new Date(app.updated_at).toLocaleDateString()}
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="version-icon-button"
          aria-label={`View ${app.app_name} version history`}
          onClick={() => onViewHistory(app)}
        >
          <History className="w-4 h-4" />
        </Button>
      </div>

      <div className="version-platform-grid">
        {/* iOS Version */}
        <div className="version-platform-card">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Apple className="w-5 h-5" />
              <span className="font-medium">iOS</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              className="version-icon-button"
              aria-label={`Edit ${app.app_name} iOS version`}
              onClick={() => onEdit(app, "ios")}
            >
              <Edit className="w-4 h-4" />
            </Button>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="version-field-label">Version</span>
              <span className="font-mono font-medium">{app.ios_version}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Build</span>
              <span className="font-mono text-sm">{app.ios_build_number}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Status</span>
              <Badge className={`version-status-badge ${statusColors[app.ios_status]}`} variant="outline">
                {app.ios_status}
              </Badge>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Force Update</span>
              <Badge className={`version-force-badge ${isEnabled(app.ios_force_update) ? "is-enabled" : "is-disabled"}`} variant="outline">
                <ShieldAlert className="w-3 h-3 mr-1" />
                {isEnabled(app.ios_force_update) ? "Enabled" : "Disabled"}
              </Badge>
            </div>
          </div>
        </div>

        {/* Android Version */}
        <div className="version-platform-card">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Smartphone className="w-5 h-5" />
              <span className="font-medium">Android</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              className="version-icon-button"
              aria-label={`Edit ${app.app_name} Android version`}
              onClick={() => onEdit(app, "android")}
            >
              <Edit className="w-4 h-4" />
            </Button>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="version-field-label">Version</span>
              <span className="font-mono font-medium">{app.android_version}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Build</span>
              <span className="font-mono text-sm">{app.android_build_number}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Status</span>
              <Badge className={`version-status-badge ${statusColors[app.android_status]}`} variant="outline">
                {app.android_status}
              </Badge>
            </div>
            <div className="flex justify-between items-center">
              <span className="version-field-label">Force Update</span>
              <Badge className={`version-force-badge ${isEnabled(app.android_force_update) ? "is-enabled" : "is-disabled"}`} variant="outline">
                <ShieldAlert className="w-3 h-3 mr-1" />
                {isEnabled(app.android_force_update) ? "Enabled" : "Disabled"}
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
